module.exports = __webpack_public_path__ + "static/img/equup2.ae848ecd.png";